<template>
  <ci-modal>
    <ci-modal-header>
      Passwort ändern
    </ci-modal-header>
    <ci-modal-body>
      <input type="password" v-model="newPassword">
      <input type="password" v-model="newPasswordConfirm">
    </ci-modal-body>
    <ci-modal-footer>
      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="onClose">Schließen</button>
      <button type="button" class="btn btn-danger" @click="onSave" :disabled="(!newPassword || !newPasswordConfirm) || (newPassword !== newPasswordConfirm)">Speichern</button>
    </ci-modal-footer>
  </ci-modal>
</template>

<script>
// components
import Modal from '@/components/Modal.vue';
import ModalBody from '@/components/ModalBody.vue';
import ModalHeader from '@/components/ModalHeader.vue';
import ModalFooter from '@/components/ModalFooter.vue';

export default {
  name: 'ModalChangePassword',

  components: {
    'ci-modal': Modal,
    'ci-modal-body': ModalBody,
    'ci-modal-footer': ModalFooter,
    'ci-modal-header': ModalHeader,
  },

  data() {
    return {
      currentPassword: null,
      newPassword: null,
      newPasswordConfirm: null,
    };
  },

  methods: {
    onClose() {
      this.$emit('modal-change-password:close');
    },

    onSave() {
      this.$emit('modal-change-password:change', {
        password: this.newPassword,
      });
    },
  },
};
</script>
